import React from "react";
import BookNow from "../../components/BookNow";
import PageTitle from "../../components/PageTitle";

const BookNowPage = () => {
  return (
    <>
      <PageTitle pageTitle="Book Your Safari" pagesub="Safari Booking" />
      <BookNow />
    </>
  );
};

export default BookNowPage;
